module.exports = __webpack_public_path__ + "assets/images/03-active_b05938d50fd83c7250d0e8d08b20db6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/03-active.png
// module id = 227
// module chunks = 0